"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.byPropertyId = void 0;
exports.byPropertyId = (state = {}, action = {}) => {
    switch (action.type) {
        case 'CALENDAR_SOURCE_GET_BY_PROPERTY_ID_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: action.payload.calendarSources });
        case 'CALENDAR_SOURCE_CREATE_RECEIVE':
            const existing = state[action.payload.propertyId] || [];
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: existing.concat([action.payload.calendarSource]) });
        case 'CALENDAR_SOURCE_DELETE_BY_ID_RECEIVE':
            const _a = state, _b = action.payload.property_id, sources = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            const filtered = sources.filter((src) => src.id !== action.payload.id);
            return Object.assign(Object.assign({}, rest), { [action.payload.property_id]: filtered });
        default:
            return state;
    }
};
//# sourceMappingURL=reducers.js.map